import auth from './auth';
import contact from './contact';
import page404 from './page404';
import dashboard from './dashboard';
import cookies from './cookies';
import validation from './validation';
import uploader from './uploader';
import modal from './modal';
import onboarding from './onboarding';
import declaration from './declaration';
import materials from './materials';
import survey from './survey';
import grades from './grades';

export default {
  auth,
  contact,
  page404,
  dashboard,
  cookies,
  validation,
  uploader,
  modal,
  onboarding,
  declaration,
  materials,
  survey,
  grades,
};
